import {
  FETCH_PARTNER_DATA,
  FETCH_PARTNER_DATA_SUCCESS,
  FETCH_PARTNER_DATA_FAILURE,
  UPDATE_PARTNER_DATA,
  UPDATE_PARTNER_DATA_SUCCESS,
  UPDATE_PARTNER_DATA_FAILURE,
  OPEN_FORM_BIO_POPUP,
  CLOSE_FORM_BIO_POPUP,
  FETCH_AFFILIATE_PARTNER,
  FETCH_AFFILIATE_PARTNER_SUCCESS,
  FETCH_AFFILIATE_PARTNER_FAILURE,
  UPDATE_AFFILIATE_PARTNER_SUCCESS,
  UPDATE_AFFILIATE_PARTNER,
  UPDATE_AFFILIATE_PARTNER_FAILURE,
} from '../constants/ActionTypes';

export default function partner(
  state = {
    errors: [],
    data: {
      rating: null,
    },
    affiliate: {
      id: null,
      sites: '',
      description: '',
    },
    isFetching: false,
    isSending: false,
    isSaved: false,
    isNotSaved: false,
    isFormBioPopupOpen: false,
  },
  action
) {
  switch (action.type) {
    case FETCH_PARTNER_DATA:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_PARTNER_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };

    case FETCH_PARTNER_DATA_FAILURE:
      return {
        ...state,
        error: [...state.errors, action.error],
        isFetching: false,
      };

    case UPDATE_PARTNER_DATA:
      return {
        ...state,
        isSending: true,
        isNotSaved: false,
        isSaved: false,
      };

    case UPDATE_PARTNER_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isSending: false,
        isNotSaved: false,
        isSaved: true,
      };

    case UPDATE_PARTNER_DATA_FAILURE:
      return {
        ...state,
        error: [...state.errors, action.error],
        isSending: false,
        isNotSaved: true,
        isSaved: false,
      };

    case OPEN_FORM_BIO_POPUP:
      return {
        ...state,
        isFormBioPopupOpen: true,
      };

    case CLOSE_FORM_BIO_POPUP:
      return {
        ...state,
        isFormBioPopupOpen: false,
      };

    case FETCH_AFFILIATE_PARTNER:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_AFFILIATE_PARTNER_FAILURE:
      return {
        ...state,
        isFetching: false,
      };

    case UPDATE_AFFILIATE_PARTNER:
      return {
        ...state,
        isSending: true,
        isNotSaved: false,
        isSaved: false,
      };

    case FETCH_AFFILIATE_PARTNER_SUCCESS:
      return {
        ...state,
        affiliate: action.data,
        isFetching: false,
      };

    case UPDATE_AFFILIATE_PARTNER_FAILURE:
      return {
        ...state,
        error: [...state.errors, action.error],
        isSending: false,
        isNotSaved: true,
        isSaved: false,
      };

    case UPDATE_AFFILIATE_PARTNER_SUCCESS:
      return {
        ...state,
        isSending: false,
        isNotSaved: false,
        isSaved: true,
      };

    default:
      return state;
  }
}
